import { gql, QueryHookOptions, useQuery } from '@apollo/client';

export const useQueryPartnerDeliveryAddresses = (
  options?: QueryHookOptions<
    PartnerDeliveryAddressesData,
    PartnerDeliveryAddressesVariables
  >,
) =>
  useQuery<PartnerDeliveryAddressesData, PartnerDeliveryAddressesVariables>(
    PARTNER_DELIVERY_ADDRESSES,
    options,
  );

export const PARTNER_DELIVERY_ADDRESSES = gql`
  query partnerDeliveryAddresses($businessPartnerId: String) {
    partnerDeliveryAddresses(businessPartnerId: $businessPartnerId) {
      name
      id
    }
  }
`;

export type PartnerDeliveryAddressesItem = {
  id: number;
  name: string;
};

export type PartnerDeliveryAddressesVariables = {
  businessPartnerId?: string;
};

export type PartnerDeliveryAddressesData = {
  partnerDeliveryAddresses: PartnerDeliveryAddressesItem[];
};
